import * as React from "react";
import moment from "moment";

import Button from "@mui/material/Button";

import {dateFormat} from "@/utils/constants";

import "./index.scss";

export default function MedicalCard(props) {
	const {element, actions} = props;

	return (
		<div className="medical-card-container">
			<div className="medical-card-header">
				<div className="top-left">
					{moment(element.startDate).format(dateFormat)}
				</div>
				<div className="top-right">
					<div className="medical-card-actions">
						{actions.map((action, key) => {
							return (
								<div key={key} className="action">
									<Button
										variant={action.variant || "contained"}
										onClick={() => action.onClick(element)}
										color={action.color || "blue"}
										size="small"
									>
										<div className="action-content d-flex align-items-center">
											<div>{action.icon && action.icon}</div>
										</div>
									</Button>
								</div>
							);
						})}
					</div>
				</div>
			</div>
			<div className="medical-card-body">
				<div className="medical-card-info">
					<div className="info-title">{element.diagnosis}</div>
				</div>
				<div className="medical-card-subinfo">
					<div className="column">
						{element.recordType === false ? (
							<div className="type-info">
								<div className="info-label">Tipologia:</div>
								<div className="info-value">{element.injuryType || "---"}</div>
							</div>
						) : null}
						<div className="type-info">
							<div className="info-label">Esame:</div>
							<div className="info-value">{element.exam || "---"}</div>
						</div>
						<div className="type-info">
							<div className="info-label">Terapia:</div>
							<div className="info-value">{element.therapy || "---"}</div>
						</div>
						<div className="type-info">
							<div className="info-label">Data di fine:</div>
							<div className="info-value">
								{element.medicalDischargeDate
									? moment(element.medicalDischargeDate).format(dateFormat)
									: "---"}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
